<template>

  <div class="mb-4" v-if="sf_account_info !== null && sfdcSearchEnabled() && ifUserCanAccess()">
    <!-- v-if="taskInfo !== null" -->
    <!--#region -- Content ---->

    <div class="stage-header mb-4">
      <div class="caption-label">
        Salesforce Account
      </div>
      <div class="row border-bottom mb-4">
        <div class="col-12">
          <div class="header-col">
            <div>Account Name</div>
            <gtc-account-link v-if=" sf_account_info!= null"
                              :opportunityId="sf_account_info.ID"
                              :opportunityName="_.get(sf_account_info, 'NAME', '')"
                              v-b-tooltip.hover.right :title="linkHoverInfo('Account')" />
          </div>
        </div>
        <div class="col-12">
          <div class="header-col">
            <div>Account Website</div>
            <div v-if="_.get(sf_account_info, 'WEBSITE', '') !== null && (_.get(sf_account_info, 'WEBSITE', '')).includes('http')">
              <a class="link"
                 target="_blank"
                 :href="sf_account_info.WEBSITE">
                {{ _.get(sf_account_info, 'WEBSITE', '') }}
              </a>
            </div>
            <div v-else>{{ _.get(sf_account_info, 'WEBSITE', '') }}</div>
          </div>
        </div>
        <!-- 1---------------------------------------------------------->
        <div class="col-4">
          <div class="header-col">
            <div>Account Owner</div>
            <div>{{ _.get(sf_account_info, 'OWNER_NAME', '') }}</div>
          </div>
          <div class="header-col">
            <div>Phone</div>
            <div>{{ _.get(sf_account_info, 'PHONE', '') }}</div>
          </div>
          <div class="header-col">
            <div>Parent Account ID</div>
            <div>{{ _.get(sf_account_info, 'PARENTID', '') }}</div>
          </div>
          <div class="header-col">
            <div>Fax</div>
            <div>{{ _.get(sf_account_info, 'FAX', '') }}</div>
          </div>

          <div class="header-col">
            <div>Account Type</div>
            <div>{{ _.get(sf_account_info, 'ACCOUNT_TYPE__C', '') }}</div>
          </div>

          <div class="header-col">
            <div>Ecosystem Engagement</div>
            <div>{{ _.get(sf_account_info, 'ECOSYSTEM_ENGAGEMENT__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Account Site</div>
            <div>{{ _.get(sf_account_info, 'SITE', '') }}</div>
          </div>
        </div>

        <!-- 2---------------------------------------------------------->
        <div class="col-4">
          <div class="header-col">
            <div>Reseller - Direct</div>
            <div>{{ _.get(sf_account_info, 'RESELLER_DIRECT__C', '') }} </div>
          </div>
          <div class="header-col">
            <div>
              Account Currency
            </div>
            <div>{{ _.get(sf_account_info, 'CURRENCYISOCODE', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Country
            </div>
            <div>{{ _.get(sf_account_info, 'COUNTRY__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Annual Revenue</div>
            <div>{{ _.get(sf_account_info, 'CURRENCYISOCODE', '') }} {{ _.get(sf_account_info, 'ANNUALREVENUE', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Account Source
            </div>
            <div>{{ _.get(sf_account_info, 'ACCOUNTSOURCE', '') }}</div>
          </div>

          <div class="header-col">
            <div>
              Number of Employees
            </div>
            <div>{{ _.get(sf_account_info, 'NUMBER_OF_EMPLOYEES__C', '') }}</div>
          </div>

          <div class="header-col">
            <div>
              Industry
            </div>
            <div>{{ _.get(sf_account_info, 'INDUSTRY', '') }}</div>
          </div>
          <div class="header-col">
            <div>
              Key Account
            </div>
            <div>{{ _.get(sf_account_info, 'KEY_ACCOUNT__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Account Tier</div>
            <div>{{ _.get(sf_account_info, 'ACCOUNT_TIER__C', '') }}</div>
          </div>
        </div>

        <!-- 0---------------------------------------------------------->


        <div class="col-4">

          <div class="header-col">
            <div>Vertical</div>
            <div>{{ _.get(sf_account_info, 'SUB_VERTICAL_INDUSTRY__C', '') }}</div>
          </div>

          <div class="header-col">
            <div>Global Enterprise Account</div>
            <div>{{_.get(sf_account_info, 'GLOBAL_ENTERPRISE_ACCOUNT__C', '') }}</div>
          </div>


          <div class="header-col">
            <div>Verticals with Expertise</div>
            <div>{{_.get(sf_account_info, 'VERTICALS_WITH_EXPERTISE__C', '') }}</div>
          </div>

          <div class="header-col">
            <div>
              Signed NDA?
            </div>
            <div>{{_.get(sf_account_info, 'SIGNED_NDA__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Owner Name for MA</div>
            <div>{{_.get(sf_account_info, 'OWNER_NAME_FOR_MA__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>Getac Site for MA</div>
            <div>
              {{_.get(sf_account_info, 'GETAC_SITE_FOR_MA__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>Sync With RW</div>
            <div>
              {{_.get(sf_account_info, 'SYNC_WITH_RW__C', '') }}
            </div>
          </div>
          <div class="header-col">
            <div>Getac Sales Territory</div>
            <div>{{_.get(sf_account_info, 'GETAC_SALES_TERRITORY__C', '') }}</div>
          </div>
          <div class="header-col">
            <div>SA In-Charge Email</div>
            <div>{{_.get(sf_account_info, 'SA_IN_CHARGE_EMAIL__C', '') }}</div>
          </div>
        </div>
      </div>

      <!-- region: Opportunity Sectoin, seperate loader-->
      <div v-if="sfdc_opty_loading" class="stage-header mb-4">
        <div class="caption-label">
          <i v-if="sfdc_opty_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
          Related Opportunity
        </div>
      </div>

      <div v-else class="stage-header mb-4">
        <div class="caption-label">
          Related Opportunity
          <b-badge style="margin-left: 5px;" v-if="sf_opty_info" variant="primary">{{sf_opty_info.length}}</b-badge>
          <b-badge style="margin-left: 5px; " v-else variant="primary">0</b-badge>
          <b-button v-if="sf_opty_info != null && _.size(sf_opty_info) > 0"
                    v-b-toggle.collapseOPPs
                    variant="outline-primary"
                    class="text-primary text-left"
                    style="background-color: white; border: none; padding-left: 39px;">
            <b-icon :icon="isCollapsedOPP ? 'chevron-down' : 'chevron-up'"></b-icon>
          </b-button>
        </div>
        <b-collapse id="collapseOPPs" @shown="onShownOPP" @hidden="onHiddenOPP" accordion="Related Opportunity" role="tabpanel">
          <b-table v-if="sf_opty_info!=null" :fields="relativeOppFields" :items="sf_opty_info"
                   small
                   thead-class="thead-light text-dark"
                   style="width: calc(100% - 10px)">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(OPPORTUNITY_NUMBER__C)="data">
              <a class="link"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ data.item.OPPORTUNITY_ID }`)">
                {{ data.item.OPPORTUNITY_NUMBER__C }}
              </a>
            </template>

            <template #cell(OPPORTUNITY_NAME)="data">
              <a class="link"
                 target="_blank"
                 :href="safeUrl(`${ frontEndUrlToUse }opportunity/opty-id/${ data.item.OPPORTUNITY_ID }`)">
                {{ data.item.OPPORTUNITY_NAME }}
              </a>
            </template>
          </b-table>
        </b-collapse>
          
      </div>
      <!-- endregion-->

      <!-- region: SalesForce Contact Loader class="caption-label-hide d-flex"  -->
      <div v-if="sfdc_contact_loading" class="stage-header mb-4">
        <div class="caption-label">
          <i v-if="sfdc_contact_loading" style="color: #f77530;" class="fa fa-circle-o-notch fa-spin fa-fw"> </i>
          Contacts
        </div>
      </div>

      <div v-else class="stage-header mb-4">
        <div class="caption-label">
          Contacts
          <b-badge style="margin-left: 5px;" v-if="sf_contact_info" variant="primary">{{sf_contact_info.length}}</b-badge>
          <b-badge style="margin-left: 5px; " v-else variant="primary">0</b-badge>
          <b-button v-if="sf_contact_info != null && _.size(sf_contact_info) > 0"
                    v-b-toggle.collapseContacts
                    variant="outline-primary"
                    class="text-primary text-left"
                    style="background-color: white; border: none; padding-left: 39px;">
            <b-icon :icon="isCollapsedContact ? 'chevron-down' : 'chevron-up'"></b-icon>
          </b-button>
        </div>
        <b-collapse id="collapseContacts" @shown="onShownContact" @hidden="onHiddenContact" accordion="Contacts" role="tabpanel">
          <b-table v-if="sf_contact_info!=null" :fields="contactFields" :items="sf_contact_info"
                   small
                   thead-class="thead-light text-dark"
                   style="width: calc(100% - 10px)">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-collapse>
          
      </div>
      <!-- endregion-->

    </div>




  </div>
  <div v-else-if="sf_account_info !== null && ifUserCanAccess() != true">
    <h3>{{`You do not have sufficient permissions to view Salesforce Account Information from this Region.\nPlease contact FTIE system administrators.`}}</h3>
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'account-page',
    props: {
      prop_account_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
      prop_user_functions: {
        default: null
      },
    },
    data() {
      return {
        function_name: 'Account Page',
        activeTab: 0,
        visible: false,
        taskInfo: null,
        sf_account_info: null,
        sf_contact_info: null,
        sf_opty_info: null,
        sfdc_opty_loading: true,
        sfdc_contact_loading: true,
        taskId: encodeURIComponent(this.$route.params.account_id),
        date_from: null,
        account_id: encodeURIComponent(this.$route.params.account_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        searching: false,
        userFunctions: null,
        userRoles: null,
        userSites: null,
        login_user_name: null,
        relativeOppFields:[
          { key: 'OPPORTUNITY_NUMBER__C', label: 'Opportunity Number', thClass: 'align-middle', sortable: true },
          { key: 'OPPORTUNITY_NAME', label: 'Opportunity Name', thClass: 'align-middle', sortable: true },
          { key: 'STAGE', label: 'Stage', thClass: 'align-middle', sortable: true },
          { key: 'PROBABILITY', label: 'Probability', thClass: 'align-middle', sortable: true },
          { key: 'VERTICAL_INDUSTRY__C', label: 'Industry', thClass: 'align-middle', sortable: true },
          { key: 'OWNER_NAME', label: 'Owner', thClass: 'align-middle', sortable: true },
          { key: 'CREATEDDATE', label: 'Created Date', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'LASTMODIFIEDDATE', label: 'Lastmodified Date', thClass: 'align-middle', sortable: true }
        ],
        contactFields: [
          { key: 'NAME', label: 'Name', thClass: 'align-middle', sortable: true },
          { key: 'EMAIL', label: 'Email', thClass: 'align-middle', sortable: true },
          { key: 'PHONE', label: 'Phone', thClass: 'align-middle', sortable: true },
          { key: 'MOBILEPHONE', label: 'Mobile Phone', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'COUNTRY__C', label: 'Country', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGCOUNTRY', label: 'Mailing Country', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGPOSTALCODE', label: 'Postal Code', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGSTATE', label: 'Mailing State', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGCITY', label: 'Mailing City', thClass: 'align-middle', sortable: true },
          { key: 'MAILINGSTREET', label: 'Mailing Street', thClass: 'align-middle', sortable: true },
          { key: 'CREATE_BY', label: 'Contact Create By', thClass: 'align-middle', sortable: true },
        ],
        //// //// ////
        missingData: 'N/A (Old data not found)',
        readOnly: false,
        access_to_opty: false,
        isCollapsedOPP: true,
        isCollapsedContact: true,
      };
    },
    created() {
      let self = this;
      self.date_from = moment().format('YYYY-MMM-DD');
      self.userSites = self.prop_user_sites;
      self.login_user_name = self.prop_user;
      self.userRoles = self.prop_user_roles;
      self.user_functions = self.prop_user_functions;
      self.checkLoggedIn();
      self.access_to_opty = self.sfdcSearchEnabled();
      
      if (self.sfdcSearchEnabled) {
        if (self.prop_account_page_obj == null) {
          self.getAccountInfo();
        } else {
          self.sf_account_info = self.prop_account_page_obj;
          self.account_id = self.sf_account_info.ID;
        }
        if (self.account_id !== null) {
          self.getRelatedOptyList();
          self.getContactInfo();
        }
      } else {
        self.sfdc_opty_loading = false;
        self.sfdc_contact_loading = false;
        this.$message.error(`You do not have permissions to access Salesforce Account Information.\nPlease contact FTIE system administrators.`);
      }
     },

    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      linkHoverInfo(linkTo){
        return `View Salesforce ${linkTo} Page (Permission Required)`;
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

      },

      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },

      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },

      getAccountInfo() {
        let self = this;

        let requestData = {
          account_id: self.account_id,
        };
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/opportunity/back-end/account-id/' + self.account_id, requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'account_info', null) !== null) {
              self.sf_account_info = JSON.parse(result.account_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (self.account_id !== null) {
              console.log("self.sf_account_info");
             // console.log(self.sf_account_info);
            }

          });
      },
      getRelatedOptyList() {
        let self = this;
        if (self.sfdcSearchEnabled) {
          let requestData = {
            account_id: self.account_id,
          };
          self.sfdc_opty_loading = true;
          this.$axios
            .post(self.$root.baseUrl + '/opportunity/back-end/relate-opty/account-id/' + self.account_id, requestData)
            .then(res => {
              let result = res.data;

              if (_.get(result, 'opty_info_list', null) !== null) {
                self.sf_opty_info = JSON.parse(result.opty_info_list);
              }
            })
            .finally(() => {
              //eventHub.$emit('loading', false);
              self.sfdc_opty_loading = false;
              if (self.account_id !== null) {
                console.log("self.sf_opty_info");
              }

            });
        } else {
          console.log("Search Disabled!!");
          self.sfdc_opty_loading = false;
          this.$message.error(`You do not have sufficient permissions to view Salesforce Opportuniy Information.\nPlease contact FTIE system administrators.`);
        }
      },
      getContactInfo() {
        let self = this;
        if (self.sfdcSearchEnabled) {
          let requestData = {
            account_id: self.account_id,
          };
          // eventHub.$emit('loading', true);
          self.sfdc_contact_loading = true;
          this.$axios
            .post(self.$root.baseUrl + '/opportunity/back-end/contact/account-id/' + self.account_id, requestData)
            .then(res => {
              let result = res.data;

              if (_.get(result, 'contact_info_list', null) !== null) {
                self.sf_contact_info = JSON.parse(result.contact_info_list);
              }
            })
            .finally(() => {
              //eventHub.$emit('loading', false);
              self.sfdc_contact_loading = false;
              if (self.account_id !== null) {
                console.log("self.sf_contact_info");
                console.log(self.sf_contact_info);
              }

            });
        } else {
          console.log("Search Disabled!!");
          self.sfdc_contact_loading = false;
          this.$message.error(`You do not have sufficient permissions to view Salesforce Contact Information.\nPlease contact FTIE system administrators.`);
        }

      },

      onTabChange(newIndex) {
        console.log("newIndex:" + newIndex);
        let self = this;

      },
      sfdcSearchEnabled() {
        let self = this;
        if (self.userRoles && (_.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
          && self.userSites && _.indexOf(self.userSites, 'Getac') > -1){
         // admin
          console.log("Account Page sfdcSearchEnabled Search Enabled [ADMIN]!!");
          return true
        }
        if (self.userFunctions && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1) {
          console.log("Account Page sfdcSearchEnabled Search Enabled [CSD]!!");
          return true
        }
        if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
          console.log("Account Page sfdcSearchEnabled Search Enabled!!");
          return true
        }
        console.log("Account Page sfdcSearchEnabled Search Disabled!!");
        console.log("userFunctions!!");
        console.log(self.userFunctions);
        return false;
      },
      onShownOPP() {
        this.isCollapsedOPP = false;
      },
      onHiddenOPP() {
        this.isCollapsedOPP = true;
      },
      onShownContact() {
        this.isCollapsedContact = false;
      },
      onHiddenContact() {
        this.isCollapsedContact = true;
      },
      ifUserCanAccess() {
        let self = this;
        console.log("ifUserCanAccess -- self.userSites:");
        console.log(self.userSites);
        console.log("ifUserCanAccess -- self.sf_account_info, 'COUNTRY__C', '')");
        console.log(_.get(self.sf_account_info, 'COUNTRY__C', ''));
        if (self.sfdcSearchEnabled()) {
          if (((self.userSites && _.indexOf(self.userSites, 'GUSA') > -1 && self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1) && self.userRoles && (_.indexOf(self.userRoles, 'GRO_SA_Leader') > -1 || _.indexOf(self.userRoles, 'GRO_SA') > -1))) {
            console.log("Can only view US opty for GUSA SA !!");
            if (_.get(self.sf_account_info, 'COUNTRY__C', '') === "United States") {
              return true
            }
            else {
              console.log("ifUserCanAccess -- retun false");
              return false
            }
          }
          console.log("Return true Account Page sfdcSearchEnabled is true, belong to admin/key account")
          return true;
        } else {
          return false
        }
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/opty-management/AccountPage.vue